// eslint-disable-next-line import/prefer-default-export

// Image Upload
export const IMAGE_UPLOAD_SIZE_MAX = 10485760; // 10MB
export const IMAGE_UPLOAD_SIZE_EXCEEDED_ERROR =
    "The image file you are trying to upload exceeds the maximum allowed size of 10MB.";
export const ALLOWED_IMAGE_FORMATS = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
export const IMAGE_FORMAT_ERROR =
    "Image file type not supported. File type we support are png, jpeg, jpg and gif. Re-upload with correct format";
export const PROFILE_REQUIRED = "Profile Photo is required";
//Policy and T&C links
export const TERMS_OF_USE_LINK = "https://unibuddy.com/terms-of-use/";
export const PRIVACY_POLICY_LINK = "https://unibuddy.com/privacy-policy/";
export const ACCEPTABLE_USE_POLICY_LINK = "https://unibuddy.com/acceptable-use-policy/";
export const COOKIE_POLICY_LINK = "https://unibuddy.com/cookie-policy/";
export const ACCESSIBILITY_POLICY_LINK = "https://unibuddy.com/accessibility-policy/";
export const SUBPROCESSORS_LINK = "https://unibuddy.com/sub-processors";

// Launch Darkly Feature flags
export const CONTENT_RELEASE3_FLAG = "ub-content-release-v3";
export const PROSPECT_STAGE_VER_A_FLAG = "ub-prospect-stage-ver-a";

export const NEXT_BEST_ACTIONS_FLAG = "ub-widget-next-best-actions";
export const DISABLE_DOUBLE_NAV_BAR = "ub-widget-disable-double-nav-bar";

export const HIDE_CONTENT_PAGE_HEADER = {
    key: "ub-widget-hide-header-text",
    value: false,
};
